import { Component, OnInit, HostBinding } from '@angular/core';
import { IField, BillFieldDataType } from 'dbweb-core';

@Component({
	selector: 'common-common-bill',
	templateUrl: './common-bill.component.html',
	styleUrls: ['./common-bill.component.scss']
})
export class CommonBillComponent implements OnInit {
	@HostBinding('class.common-bill') hostClass = true;
	constructor() {}

	ngOnInit() {}
	inputType(fld: IField) {
		switch (fld.Type) {
			default:
				return 'text';
			case BillFieldDataType.DATE:
				return 'datetime-local';
			case BillFieldDataType.FLOAT:
			case BillFieldDataType.INT:
				return 'number';
		}
	}
}
